import styled from 'styled-components';
import { rem } from 'polished';
var DescriptionContainer = styled.div.withConfig({
  displayName: "DescriptionContainer",
  componentId: "sc-180b4bv-0"
})(["padding-left:", ";padding-right:", ";"], function (_ref) {
  var horizontalSpacing = _ref.horizontalSpacing;
  return horizontalSpacing ? rem(horizontalSpacing) : 0;
}, function (_ref2) {
  var horizontalSpacing = _ref2.horizontalSpacing;
  return horizontalSpacing ? rem(horizontalSpacing) : 0;
});
export default DescriptionContainer;